import { z } from "zod";

import { monthlyAuditDate } from "@/schemas";

import {
  environmentalChecklistItem,
  environmentalChecklistItemWithTicket,
} from "../../../../schemas";

export const resEnvChecklistMiscSchema = z.object({
  auditDate: monthlyAuditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  miscAirFilters: environmentalChecklistItem,
  miscPlumbingVisual: environmentalChecklistItemWithTicket,
  miscExhaustFan: environmentalChecklistItemWithTicket,
  miscCarpets: environmentalChecklistItemWithTicket,
  miscMechanicalRoom: environmentalChecklistItem,
  miscHotWater: environmentalChecklistItem,
  miscCaulking: environmentalChecklistItemWithTicket,
  miscDoorLock: environmentalChecklistItemWithTicket,
  miscExits: environmentalChecklistItem,
  miscFaucetToilet: environmentalChecklistItemWithTicket,
  miscCeiling: environmentalChecklistItemWithTicket,
  miscWindows: environmentalChecklistItemWithTicket,
  miscMedicalRecord: environmentalChecklistItem,
  miscSpaceHeater: environmentalChecklistItem,
});
